if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        // Same call a thumbnail tap makes. Uploaded videos ignore it (they play
        // from what is on screen, cs-gallery-video.js); YouTube/3D still unpack here.
        this.playActiveMedia(event.detail.currentElement);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        // Uploaded videos play and pause themselves from what is on screen
        // (assets/cs-gallery-video.js). Forcing play() here, after a pause-all
        // and a rewind to 0 on every slide change, is what made them glitch
        // ("its glitchy", 21 Oct 2026). Only deferred media (YouTube, Vimeo,
        // 3D) still needs Dawn's unpack.
        if (activeItem.querySelector('[data-cs-gvid]')) return;
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (!deferredMedia) return;
        window.pauseAllMedia();
        if (typeof deferredMedia.loadContent === 'function') deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

/* ============================================================================
   ?viddebug=1 — why is this video not playing, on THIS handset.

   Added 22-Sep-2026 after two fixes that worked in every emulator and still
   failed on Yash's phone, including in a private window. Emulated Chromium
   cannot reproduce iOS Low Power Mode, Low Data Mode, or a Safari policy
   quirk, so the phone has to report for itself. Costs nothing unless the
   query parameter is present.
   ========================================================================== */
(function () {
  if (location.search.indexOf('viddebug=1') === -1) return;

  var log = [];
  var origPlay = HTMLMediaElement.prototype.play;
  HTMLMediaElement.prototype.play = function () {
    var r = origPlay.apply(this, arguments);
    if (r && r.catch) r.catch(function (e) { log.push('play() REJECTED: ' + e.name + ' — ' + (e.message || '').slice(0, 60)); });
    else log.push('play() returned no promise (old browser)');
    return r;
  };

  var slideChanged = 0, touchEnds = 0;
  document.addEventListener('slideChanged', function () { slideChanged++; }, true);
  document.addEventListener('touchend', function () { touchEnds++; }, true);

  var box = document.createElement('pre');
  box.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:2147483647;margin:0;background:#111;' +
    'color:#0f0;font:11px/1.35 monospace;padding:8px;white-space:pre-wrap;max-height:46vh;overflow:auto';
  var NL = String.fromCharCode(10);
  (document.body || document.documentElement).appendChild(box);

  setInterval(function () {
    var dm = document.querySelector('.product__media-list deferred-media');
    var v = document.querySelector('.product__media-list video');
    var c = navigator.connection || {};
    var lines = [
      'slideChanged fired : ' + slideChanged,
      'touchend fired     : ' + touchEnds,
      'deferred unpacked  : ' + (dm ? dm.hasAttribute('loaded') : 'no deferred-media'),
      'video element      : ' + (v ? 'yes' : 'NO — still in <template>'),
      v ? 'paused / muted     : ' + v.paused + ' / ' + v.muted : '',
      v ? 'readyState        : ' + v.readyState + '  (0=nothing 4=can play through)' : '',
      v ? 'networkState      : ' + v.networkState + '  (3 = NO SOURCE)' : '',
      v ? 'currentTime       : ' + v.currentTime.toFixed(2) : '',
      v ? 'error             : ' + (v.error ? ('code ' + v.error.code) : 'none') : '',
      v ? 'src               : ' + (v.currentSrc || '(none)').split('/').pop().slice(0, 40) : '',
      'saveData / netType : ' + (c.saveData === true) + ' / ' + (c.effectiveType || '?'),
      'reduced motion     : ' + window.matchMedia('(prefers-reduced-motion: reduce)').matches,
      '--- play() results ---'
    ].filter(Boolean).concat(log.slice(-6));
    box.textContent = lines.join(NL);
  }, 500);
})();
